import {MedlemsRollePeriode2Modell} from "../tjenester/ressurser/generertNg2HttpKlient";
import {første} from "felles-ng2/støttefunksjoner/lister";


/** Returnerer den første rollen i angitt liste, null dersom listen er tom */
export function primærRolle(roller: MedlemsRollePeriode2Modell[]): MedlemsRollePeriode2Modell | null {
    return første(roller);
}

/** Returnerer den første rollen i angitt liste, tom streng dersom listen er tom */
export function primærRolleSomStreng(roller: MedlemsRollePeriode2Modell[]): string {
    return primærRolle(roller)?.tittel ?? '';
}
